<template>
  <div class="row justify-content-center mt-5">
    <div class="col-lg-5 col-md-7">
      <card shadow type="secondary">
        <v-card-title class="justify-center">LOG IN</v-card-title>
        <v-form class="v-form-body" ref="form" v-on:keyup.native.enter="validate" v-model="valid" lazy-validation>
          <label class="form-control-label">Email
            <span class="red--text">*</span>
          </label>
          <v-text-field
            v-model="email"
            :rules="emailRules"
            placeholder="E-mail"
            required
            solo
            prepend-inner-icon="email"
          ></v-text-field>

          <label class="form-control-label">Password
            <span class="red--text">*</span>
          </label>
          <v-text-field
            v-model="password"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min]"
            :type="show1 ? 'text' : 'password'"
            name="input-10-1"
            placeholder="Password"
            hint="Password should not be less than 8 characters"
            counter
            @click:append="show1 = !show1"
            prepend-inner-icon="lock"
            solo
          ></v-text-field>
          <v-btn :disabled="!valid" color="primary" class="mr-4" @click="validate">Login</v-btn>
        </v-form>
      </card>
    </div>
  </div>
</template>

<script>
import { AuthService } from "../services";
import { PANEL } from "@/constants";
import NodeRSA from "node-rsa";

export default {
  name: "Login",
  data() {
    return {
      valid: true,
      email: "",
      emailRules: [
        v => !!v || "E-mail is required!",
        v =>
          /.+@.+\..+/.test(v) || "You have entered an invalid e-mail address."
      ],
      show1: false,
      password: "",
      rules: {
        required: value => !!value || "Password is required!",
        min: v =>
          v.length >= 8 || "Your password should not be less than 8 characters"
      }
    };
  },
  methods: {
    async validate() {
      if (this.$refs.form.validate()) {
        const key = new NodeRSA(process.env.VUE_APP_PRIVATEKEY);
        this.snackbar = true;
        const response = await AuthService.login({
          email: this.email,
          password: key.encrypt(this.password, 'base64'),
          panel: PANEL.toLowerCase()
        });
        if (response) {
          this.$store.dispatch("user/setToken", response.data.token);
          this.$store.dispatch("user/setUser", response.data.user);
          this.$router.push("/dashboard");
        }
      }
    }
  }
};
</script>
<style></style>
